(() => {
  const selector = 'slider-component[data-islander-loop-slider]';

  function initialiseLoopingCarousel(component) {
    if (component.dataset.loopInitialised === 'true') return;

    const slider = component.querySelector('[id^="Slider-"]');
    const previousButton = component.querySelector('button[name="previous"]');
    const nextButton = component.querySelector('button[name="next"]');

    if (!slider || !previousButton || !nextButton) return;

    component.dataset.loopInitialised = 'true';
    component.enableSliderLooping = true;
    previousButton.removeAttribute('disabled');
    nextButton.removeAttribute('disabled');

    component.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest('button[name="previous"], button[name="next"]');
        if (!button || !component.contains(button)) return;

        const maximumScroll = Math.max(0, slider.scrollWidth - slider.clientWidth);
        const isAtStart = slider.scrollLeft <= 2;
        const isAtEnd = maximumScroll - slider.scrollLeft <= 2;
        const shouldWrapBackward = button.name === 'previous' && isAtStart;
        const shouldWrapForward = button.name === 'next' && isAtEnd;

        if (!shouldWrapBackward && !shouldWrapForward) return;

        event.preventDefault();
        event.stopPropagation();

        slider.scrollTo({
          left: shouldWrapBackward ? maximumScroll : 0,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      },
      true
    );
  }

  function initialiseCarousels(container = document) {
    container.querySelectorAll(selector).forEach(initialiseLoopingCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseCarousels());
  } else {
    initialiseCarousels();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseCarousels(event.target));
})();
